module.exports = __webpack_public_path__ + "../../img/PLUG_PLAY.7b523237.png";